import React, { useState, useEffect } from "react";
import Api from "../../components/api/Api";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import Notification, {
  showToast,
} from "../../../components/common/notification/Notification";
import { Link, useParams } from "react-router-dom";
import SingleDetailHeader from "../../components/singleDetail/SingleDetailHeader";
import SingleDetail from "../../components/singleDetail/SingleDetail";
import BreadCrumb from "../../components/breadcrumb/BreadCrumb";
import AdminHeader from "../../common/Header";
import { 
  FiTag, FiInfo, FiClock, FiGift, 
  FiCheckCircle, FiXCircle, FiCalendar, 
  FiLayers 
} from "react-icons/fi";

const SubscriptionItem = () => {
  const { Id } = useParams();

  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);

  const getSubscriptionDetaiils = Api({
    url: `api/subscription/plan/details/${Id}`,
  });

  const [formData, setFormData] = useState({
    name: "",
    description: "",
  });

  useEffect(() => {
    const fetchPostData = async () => {
      try {
        setIsLoading(true);
        const response = await getSubscriptionDetaiils.fetchDataBySingleId(true);
        console.log(response);
        if (response?.data?.statusType === "SUCCESS") {
          const postData = response.data.subscriptionPlan;

          setFormData(postData);
        }
      } catch (error) {
        setIsError(true);
        console.error(error);
        showToast("Error Occurred", { type: "error" });
      } finally {
        setIsLoading(false);
      }
    };

    fetchPostData();
  }, []);
  const breadcrumbItems = [
    { label: "", link: "/admin", icon: "fa-solid fa-house" },
    { label: "Master", link: "/user" },
    { label: "Subscription plan", link: "/subscription-plans" },
    { label: "Subscription plan Details", link: "", active: true },
  ];
  return (
    <>
      <Notification />
      <Container>
        <BreadCrumb items={breadcrumbItems} />
        <Row>
          <Col lg={3} md={4} sm={12}>
            <AdminHeader />
          </Col>
          <Col lg={9} md={8} sm={12}>
            <SingleDetailHeader
              header="Subscription plan Details"
              description="Subscription plan details section"
            />

<div className="container py-3">

  {/* Subscription Plan Header */}
  <h4 className="mb-4 d-flex align-items-center text-primary">
    <FiLayers className="me-2" /> Subscription Plan Details
  </h4>

  <Row className="mb-3">
    <Col md={4} className="fw-bold">
      <FiTag className="me-2 text-secondary" /> Plan Name
    </Col>
    <Col md={8}>{formData?.plan_name}</Col>
  </Row>

  <Row className="mb-3">
    <Col md={4} className="fw-bold">
      <FiInfo className="me-2 text-secondary" /> Plan Code
    </Col>
    <Col md={8}>{formData?.plan_code}</Col>
  </Row>

  <Row className="mb-3">
    <Col md={4} className="fw-bold">
      <FiInfo className="me-2 text-secondary" /> Description
    </Col>
    <Col md={8}>{formData?.plan_description}</Col>
  </Row>

  <Row className="mb-3">
    <Col md={4} className="fw-bold">
      <FiGift className="me-2 text-warning" /> Offer
    </Col>
    <Col md={8} className="text-success fw-semibold">
      {formData?.offer_text}
    </Col>
  </Row>

  <Row className="mb-3">
    <Col md={4} className="fw-bold">
      <FiClock className="me-2 text-primary" /> Duration
    </Col>
    <Col md={8}>{formData?.duration_days} Days</Col>
  </Row>

  <Row className="mb-3">
    <Col md={4} className="fw-bold">
      <span className="me-2 text-success" style={{ fontSize: "1.1rem" }}>₹</span> Price
    </Col>
    <Col md={8} className="fw-bold text-success">
      ₹ {(formData?.price_paise / 100).toLocaleString()}
    </Col>
  </Row>

  <Row className="mb-3">
    <Col md={4} className="fw-bold">
      {formData?.gst_included ? (
        <FiCheckCircle className="me-2 text-success" />
      ) : (
        <FiXCircle className="me-2 text-danger" />
      )}
      GST Included
    </Col>
    <Col md={8}>
      {formData?.gst_included ? (
        <span className="text-success">Yes</span>
      ) : (
        <span className="text-danger">No</span>
      )}
    </Col>
  </Row>

  <Row className="mb-3">
    <Col md={4} className="fw-bold">
      <FiGift className="me-2 text-warning" /> Discount
    </Col>
    <Col md={8} className="text-info fw-bold">
      {formData?.discount_percentage}%
    </Col>
  </Row>

  <Row className="mb-3">
    <Col md={4} className="fw-bold">
      {formData?.auto_renew ? (
        <FiCheckCircle className="me-2 text-success" />
      ) : (
        <FiXCircle className="me-2 text-danger" />
      )}
      Auto Renew
    </Col>
    <Col md={8}>
      {formData?.subscriptionPlan?.auto_renew ? (
        <span className="text-success">Enabled</span>
      ) : (
        <span className="text-danger">Disabled</span>
      )}
    </Col>
  </Row>

  {/* <Row className="mb-4">
    <Col md={4} className="fw-bold">
      <FiCalendar className="me-2 text-secondary" /> Created On
    </Col>
    <Col md={8}>{formData?.subscriptionPlan?.created_on}</Col>
  </Row> */}


  {/* Service Section */}
  <h4 className="mb-4 mt-5 d-flex align-items-center text-primary">
    <FiLayers className="me-2" /> Service Details
  </h4>

  <Row className="mb-3">
    <Col md={4} className="fw-bold">
      <FiTag className="me-2 text-secondary" /> Service Name
    </Col>
    <Col md={8}>{formData?.service?.name}</Col>
  </Row>

  <Row className="mb-3">
    <Col md={4} className="fw-bold">
      <FiInfo className="me-2 text-secondary" /> Description
    </Col>
    <Col md={8}>{formData?.service?.description}</Col>
  </Row>

  <Row className="mb-3">
    <Col md={4} className="fw-bold">
      {formData?.service?.active ? (
        <FiCheckCircle className="me-2 text-success" />
      ) : (
        <FiXCircle className="me-2 text-danger" />
      )}
      Active
    </Col>
    <Col md={8}>
      {formData?.service?.active ? (
        <span className="text-success">Active</span>
      ) : (
        <span className="text-danger">Inactive</span>
      )}
    </Col>
  </Row>

  {/* <Row className="mb-3">
    <Col md={4} className="fw-bold">
      <FiCalendar className="me-2 text-secondary" /> Created On
    </Col>
    <Col md={8}>{formData?.service?.created_on}</Col>
  </Row> */}

</div>

            <div>
              <Button className={`btn btn-primary mb-3 mt-3 ml-3`}>
                <Link
                  className="text-white"
                  to={`/subscription-plans/${Id}/edit`}
                >
                  Edit
                </Link>
              </Button>

              <Link
                style={{ marginLeft: "1rem" }}
                className="btn btn-primary mb-3 mt-3 ml-3"
                to={"/subscription-plans"}
              >
                Back
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default SubscriptionItem;
